import {
  STORE_CHILD_OFFER,
  ADD_CHILD_OFFER,
  REPLACE_CHILD_OFFER,
  DELETE_CHILD_OFFER,
  REMOVE_CHILD_OFFER,
  VALIDATE_USER_INPUT,
  SET_ERROR_MESSAGE,
  SET_CHILD_OFFERS,
  RESET,
  RESET_ERRORS,
  UPDATE_CHILD_OFFER,
  EDIT_CHILD_OFFER,
  EDIT_CHILD_OFFER_END,
  SET_LOADING,
} from './constants';

/**
 *
 * @param offer
 * @returns {{type: *, offer: *}}
 */
export function storeChildOffer(offer) {
  return {
    type: STORE_CHILD_OFFER,
    offer,
  };
}

/**
 * @param id
 * @param data
 * @returns {{type: *, id: *, data: *}}
 */
export function updateChildOffer(id, data) {
  return {
    type: UPDATE_CHILD_OFFER,
    id,
    data,
  };
}

/**
 * @param id
 * @returns {{type: *, id: *}}
 */
export function setEditMode(id) {
  return {
    type: EDIT_CHILD_OFFER,
    id,
  };
}

/**
 * @returns {{type: *}}
 */
export function unsetEditMode() {
  return {
    type: EDIT_CHILD_OFFER_END,
  };
}

export function setLoading(loading) {
  return {
    type: SET_LOADING,
    loading,
  };
}

/**
 *
 * @param offer
 * @returns {{type: *, offer: *}}
 */
export function addChildOffer(offer) {
  return {
    type: ADD_CHILD_OFFER,
    offer,
  };
}

/**
 *
 * @param offer
 * @returns {{type: *, offer: *}}
 */
export function replaceChildOffer(offer) {
  return {
    type: REPLACE_CHILD_OFFER,
    offer,
  };
}

/**
 *
 * @param id
 * @returns {{type: *, id: *}}
 */
export function deleteChildOffer(id) {
  return {
    type: DELETE_CHILD_OFFER,
    id,
  };
}

/**
 *
 * @param id
 * @returns {{type: *, id: *}}
 */
export function removeChildOffer(id) {
  return {
    type: REMOVE_CHILD_OFFER,
    id,
  };
}

/**
 *
 * @param hasError
 * @returns {{hasError: *, type: *}}
 */
export function setHasError(hasError) {
  return {
    type: VALIDATE_USER_INPUT,
    hasError,
  };
}

/**
 *
 * @param msg
 * @returns {{msg: *, type: *}}
 */
export function setErrorMsg(msg) {
  return {
    type: SET_ERROR_MESSAGE,
    msg,
  };
}

/**
 *
 * @param offers
 * @returns {{offers: *, type: *}}
 */
export function setChildOffers(offers) {
  return {
    type: SET_CHILD_OFFERS,
    offers,
  };
}

/**
 *
 * @returns {{type: *}}
 */
export function resetStore() {
  return {
    type: RESET,
  };
}

/**
 *
 * @returns {{type: *}}
 */
export function resetErrors() {
  return {
    type: RESET_ERRORS,
  };
}
